<script>
let modalSequence = 0
</script>

<script setup>
defineOptions({ name: 'AppModal' })

const props = defineProps({
  show: Boolean,
  fullscreen: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close'])
const titleId = `app-modal-title-${++modalSequence}`
</script>

<template>
  <div
    v-if="props.show"
    class="modal-overlay"
  >
    <div
      :class="['modal-box', { full: props.fullscreen }]"
      role="dialog"
      aria-modal="true"
      :aria-labelledby="titleId"
    >
      <button
        type="button"
        class="modal-close"
        aria-label="Close modal"
        @click="emit('close')"
      >
        ✕
      </button>

      <h2 :id="titleId" class="modal-title">
        <slot name="title" />
      </h2>

      <div class="section body">
        <slot />
      </div>

      <div class="modal-footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>
